import {
  SELECT_MONTH,
  SELECT_NEXT_MONTH,
  SELECT_PREVIOUS_MONTH,
  DISPLAY_INFOBOX,
  HIDE_INFOBOX,
  ADD_AREA_TO_SELECTION,
  REMOVE_AREA_FROM_SELECTION,
  REMOVE_ALL_AREAS_FROM_SELECTION,
  SHOW_SELECTION,
  HIDE_SELECTION,
  HIDE_PROMO
} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

// IMPORTANT: Note that with Redux, state should NEVER be changed.
// State is considered immutable. Instead,
// create a copy of the state passed and set new values on the copy.
// Note that I'm using Object.assign to create a copy of current state
// and update values on the copy.
export default function selectionReducer(state = initialState.selection, action) {

  // Make a copy of the existing array
  let area_ids = state.area_ids.slice();
  let next_month;
  let previous_month;

  switch (action.type) {
    case SELECT_MONTH:
      return objectAssign({}, state, {currentMonth: action.value});

    case SELECT_NEXT_MONTH:
      if (state.currentMonth == 12){
        next_month = 1;
      }
      else {
        next_month = state.currentMonth + 1;
      }
      return objectAssign({}, state, {currentMonth: next_month});

    case SELECT_PREVIOUS_MONTH:
      if (state.currentMonth == 1){
        previous_month = 12;
      }
      else {
        previous_month = state.currentMonth - 1;
      }
      return objectAssign({}, state, {currentMonth: previous_month});

    case DISPLAY_INFOBOX:
      return objectAssign({}, state, {
        infobox_area_id: action.value,
        displayed: false
      });

    case HIDE_INFOBOX:
      return objectAssign({}, state, {infobox_area_id: action.value});

    case ADD_AREA_TO_SELECTION:
      // add the new value
      area_ids.push(action.value);
      return objectAssign({}, state, {
        area_ids: area_ids,
        infobox_area_id: false
      });

    case REMOVE_AREA_FROM_SELECTION:
      // Remove the current value
      for (let i=area_ids.length-1; i>=0; i--) {
          if (area_ids[i] === action.value) {
              area_ids.splice(i, 1);
          }
      }
      return objectAssign({}, state, {area_ids: area_ids});

    case REMOVE_ALL_AREAS_FROM_SELECTION:
      return objectAssign({}, state, {
        displayed: false,
        area_ids: []
      });

    case SHOW_SELECTION:
      return objectAssign({}, state, {
        displayed: action.value,
        infobox_area_id: false
      });

    case HIDE_SELECTION:
      return objectAssign({}, state, {displayed: action.value});

    case HIDE_PROMO:
      return objectAssign({}, state, {
        promoDisplayed: false
      });



    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/selectionReducer.js
 **/